import React, { useMemo } from 'react';
import './TestsPage.css';

const READING_SETS = {
  lettres: [
    ['Le chat dort sur le tapis', 'La lampe éclaire la table'],
    ['Marie range ses lunettes', 'Paul ouvre un petit livre'],
    ['Le patient lit calmement', 'La lecture reste confortable'],
    ['Le soleil entre ici', 'La vision devient plus fine'],
    ['Le test demande attention', 'Chaque mot doit rester net'],
    ['La monture tient bien', 'Le regard reste centré'],
    ['La ligne semble très fine', 'Le contraste reste suffisant'],
    ['Le texte paraît plus petit', 'La lecture reste possible'],
    ['Les derniers mots sont fins', 'Le contraste aide encore'],
    ['La taille devient difficile', 'Les lettres restent visibles'],
    ['La dernière ligne est très fine', 'La lecture demande effort'],
  ],
};

const FONT_STEPS = [48, 40, 34, 28, 22, 18, 14, 12, 10, 9, 8];

export default function ReadingTestPage({ goTo }) {
  const distance = 40;

  const lines = useMemo(() => {
    return READING_SETS.lettres.map((pair, index) => ({
      id: `lettres-${index}`,
      textTop: pair[0].toUpperCase(),
      textBottom: pair[1].toUpperCase(),
      size: FONT_STEPS[index] ?? 8,
    }));
  }, []);

  return (
    <div className="test-shell">
      <div
        className="test-panel glass-card"
        style={{
          maxWidth: '1200px',
          width: '90%',
          margin: '0 auto',
        }}
      >
        <div className="test-topbar">
          <div>
            <h1>Test de lecture VP</h1>
            <p>Lecture de près avec deux phrases par taille.</p>
          </div>
          <div className="test-actions">
            <button onClick={() => goTo('tests')}>⬅ Tests</button>
          </div>
        </div>

        <div
          className="reading-grid"
          style={{
            display: 'block',
            width: '100%',
            maxWidth: '100%',
            margin: '0 auto',
          }}
        >
          <section
            className="reading-chart"
            style={{
              width: '100%',
              maxWidth: '100%',
              boxSizing: 'border-box',
              padding: '30px 40px',
              minHeight: '70vh',
              margin: '0 auto',
            }}
          >
            {lines.map((line, index) => (
              <div
                key={line.id}
                className="reading-line"
                style={{
                  marginBottom: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: '16px',
                }}
              >
                <div
                  className="reading-text"
                  style={{
                    fontSize: `${line.size}px`,
                    lineHeight: 1.2,
                    textAlign: 'center',
                    flex: 1,
                  }}
                >
                  <div>{line.textTop}</div>
                  <div>{line.textBottom}</div>
                </div>

                <span
                  style={{
                    minWidth: '80px',
                    textAlign: 'right',
                    opacity: 0.7,
                    fontSize: '14px',
                  }}
                >
                  Ligne {index + 1}
                </span>
              </div>
            ))}

            <p className="reading-note" style={{ marginTop: '28px' }}>
              Distance conseillée : {distance} cm
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}